
// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { 
//   Button, 
//   Text, 
//   makeStyles, 
//   shorthands,
//   Badge,
//   Tooltip
// } from '@fluentui/react-components';
// import { 
//   ClipboardTask20Regular, 
//   DocumentAdd20Regular,
//   BookGlobe20Regular,
//   ChevronDown20Regular,
//   ChevronUp20Regular,
//   ChevronLeft16Regular,
//   ChevronRight16Regular
// } from '@fluentui/react-icons';
// import { toast } from 'react-hot-toast';
// import { replaceSelectedContent } from "../utils/officeUtils";

// const useStyles = makeStyles({
//   container: {
//     display: 'flex',
//     flexDirection: 'column',
//     padding: '8px 4px',
//     backgroundColor: 'transparent',
//   },
//   card: {
//     backgroundColor: '#ffffff',
//     ...shorthands.border('1px', 'solid', '#e0e0e0'),
//     ...shorthands.borderRadius('6px'),
//     boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//     display: 'flex',
//     flexDirection: 'column',
//     overflow: 'hidden',
//   },
//   // Pagination Header styles
//   paginationBar: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '6px 12px',
//     backgroundColor: '#f3f2f1',
//     borderBottom: '1px solid #e0e0e0',
//   },
//   resultsCount: {
//     fontSize: '11px',
//     fontWeight: '700',
//     color: '#022366',
//   },
//   cardHeader: {
//     padding: '12px 16px',
//     backgroundColor: '#ffffff',
//     borderBottom: '1px solid #f0f0f0',
//   },
//   titleLink: {
//     fontSize: '13.5px',
//     fontWeight: '600',
//     color: '#022366',
//     textDecorationLine: 'none',
//     display: 'inline-block',
//     marginBottom: '6px',
//     lineHeight: '1.4',
//     ':hover': {
//       textDecorationLine: 'underline',
//       color: '#011640',
//     }
//   },
//   authorText: {
//     fontSize: '11.5px',
//     color: '#505050',
//     fontStyle: 'italic',
//     display: 'block',
//     marginBottom: '4px',
//   },
//   citationLine: {
//     fontSize: '10.5px',
//     color: '#707070',
//     display: 'flex',
//     alignItems: 'center',
//     flexWrap: 'wrap',
//     gap: '6px',
//     marginTop: '4px',
//   },
//   badgeRow: {
//     display: 'flex',
//     gap: '6px',
//     marginTop: '8px',
//     flexWrap: 'wrap',
//   },
//   contentBody: {
//     padding: '14px 16px',
//     fontSize: '12px',
//     color: '#333333',
//     lineHeight: '1.6',
//     backgroundColor: '#ffffff',
//     maxHeight: '300px',
//     overflowY: 'auto',
//   },
//   sectionBlock: {
//     marginBottom: '10px',
//   },
//   sectionTitle: {
//     fontWeight: '700',
//     color: '#022366',
//     fontSize: '11.5px',
//     textTransform: 'uppercase',
//     letterSpacing: '0.5px',
//     display: 'block',
//     marginTop: '8px',
//     marginBottom: '4px',
//   },
//   paragraph: {
//     margin: '0 0 8px 0',
//   },
//   cardFooter: {
//     padding: '8px 16px',
//     backgroundColor: '#fafafa',
//     borderTop: '1px solid #f0f0f0',
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     flexWrap: 'wrap',
//     gap: '8px',
//   },
//   footerActions: {
//     display: 'flex',
//     gap: '8px',
//   },
//   actionBtn: {
//     fontSize: '11px',
//     minWidth: 'auto',
//     padding: '4px 10px',
//   },
//   toggleBtn: {
//     color: '#605e5c',
//     fontSize: '11px',
//     display: 'flex',
//     alignItems: 'center',
//     gap: '4px',
//     cursor: 'pointer',
//     userSelect: 'none',
//     ':hover': {
//       color: '#022366',
//     }
//   }
// });

// const parseSectionContent = (text, classes) => {
//   if (!text) return null;
//   const chunks = text.split('\n');

//   return chunks.map((chunk, index) => {
//     const trimmed = chunk.trim();
//     if (!trimmed) return null;

//     if (trimmed.includes('::')) {
//       const parts = trimmed.split('::');
//       const title = parts[0].trim();
//       const body = parts.slice(1).join('::').trim();

//       return (
//         <div key={index} className={classes.sectionBlock}>
//           <span className={classes.sectionTitle}>{}</span>
//           {body && <p className={classes.paragraph}>{body}</p>}
//         </div>
//       );
//     }
//     return <p key={index} className={classes.paragraph}>{trimmed}</p>;
//   });
// };

// const SemanticSearchResults = ({ results, onLogCopy }) => {
//   const styles = useStyles();
//   const [currentIndex, setCurrentIndex] = useState(0);
//   const [isExpanded, setIsExpanded] = useState(false);

//   if (!results || results.length === 0) {
//     return (
//       <div style={{ padding: '16px', textAlign: 'center', color: '#605e5c' }}>
//         No search results matched your query criteria.
//       </div>
//     );
//   }

//   // Retrieve the single active article card to show
//   const item = results[currentIndex];
//   const meta = item.metadata || {};
//   const truncatedSnippet = item.content && item.content.length > 220 
//     ? item.content.substring(0, 220) + '...' 
//     : item.content;

//   const handleCopyCitation = () => {
//     const citation = `"${meta.title}." ${meta.author}. ${meta.journal} ${meta.year};${meta.volume || ''}:${meta.pages || ''}. doi:${meta.doi}`;
//     navigator.clipboard.writeText(citation);
//     toast.success("Citation copied to clipboard!");
//     if (onLogCopy) onLogCopy(meta.id);
//   };

//   const handleInsertToWord = async () => {
//     const insertionText = `${meta.title} (${meta.author}, ${meta.year}. ${meta.journal}).`;
//     try {
//       if (window.Word) {
//         await replaceSelectedContent(insertionText);
//         toast.success("Reference inserted into document!");
//         if (onLogCopy) onLogCopy(meta.id);
//       } else {
//         toast.error("Word Context missing. Copying citation instead.");
//         navigator.clipboard.writeText(insertionText);
//       }
//     } catch (err) {
//       console.error("Word insertion failed:", err);
//       toast.error("Could not write to document.");
//     }
//   };

//   return (
//     <div className={styles.container}>
//       <div className={styles.card}>
        
//         {/* 1. Carousel Navigation Bar (Locks to top) */}
//         <div className={styles.paginationBar}>
//           <Button 
//             appearance="subtle" 
//             icon={<ChevronLeft16Regular />} 
//             disabled={currentIndex === 0} 
//             size="small"
//             onClick={() => {
//               setCurrentIndex(prev => prev - 1);
//               setIsExpanded(false); // Reset expansion for cleaner transitions
//             }}
//           >
//             Prev
//           </Button>
          
//           <Text className={styles.resultsCount}>
//             Document {currentIndex + 1} of {results.length}
//           </Text>

//           <Button 
//             appearance="subtle" 
//             icon={<ChevronRight16Regular />} 
//             iconPosition="after"
//             disabled={currentIndex === results.length - 1} 
//             size="small"
//             onClick={() => {
//               setCurrentIndex(prev => prev + 1);
//               setIsExpanded(false);
//             }}
//           >
//             Next
//           </Button>
//         </div>

//         {/* 2. Unified Header */}
//         <div className={styles.cardHeader}>
//           <a 
//             href={meta.url || `https://doi.org/${meta.doi}`} 
//             target="_blank" 
//             rel="noopener noreferrer" 
//             className={styles.titleLink}
//           >
//             {meta.title}
//           </a>
//           <span className={styles.authorText}>
//             {meta.author || 'Unknown Authors'}
//           </span>
//           <div className={styles.citationLine}>
//             <BookGlobe20Regular style={{ color: '#022366', fontSize: '13px' }} />
//             <Text size={100} weight="semibold">{meta.journal}</Text>
//             <Text size={100} color="neutralSecondary">•</Text>
//             <Text size={100}>{meta.year || 'N/A'}</Text>
//             {meta.volume && (
//               <>
//                 <Text size={100} color="neutralSecondary">•</Text>
//                 <Text size={100}>Vol: {meta.volume}</Text>
//               </>
//             )}
//           </div>

//           <div className={styles.badgeRow}>
//             {meta.data_provider && (
//               <Badge appearance="filled" style={{ backgroundColor: '#022366', color: '#fff', fontSize: '9px' }}>
//                 {meta.data_provider}
//               </Badge>
//             )}
//             {meta.doi && (
//               <Badge appearance="outline" style={{ fontSize: '9px', borderColor: '#e0e0e0' }}>
//                 DOI: {meta.doi}
//               </Badge>
//             )}
//           </div>
//         </div>

//         {/* 3. Render only the active snippet/content block */}
//         <div className={styles.contentBody}>
//           {isExpanded ? (
//             parseSectionContent(item.content, styles)
//           ) : (
//             <p className={styles.paragraph}>{truncatedSnippet}</p>
//           )}
//         </div>

//         {/* 4. Actions Row */}
//         <div className={styles.cardFooter}>
//           <div className={styles.toggleBtn} onClick={() => setIsExpanded(!isExpanded)}>
//             {isExpanded ? (
//               <>
//                 <Text size={100}>Collapse view</Text>
//                 <ChevronUp20Regular style={{ fontSize: '12px' }} />
//               </>
//             ) : (
//               <>
//                 <Text size={100}>Expand full text</Text>
//                 <ChevronDown20Regular style={{ fontSize: '12px' }} />
//               </>
//             )}
//           </div>

//           <div className={styles.footerActions}>
//             <Tooltip content="Copy citation template to clipboard" relationship="label">
//               <Button 
//                 appearance="subtle" 
//                 icon={<ClipboardTask20Regular />} 
//                 className={styles.actionBtn}
//                 onClick={handleCopyCitation}
//               >
//                 Copy
//               </Button>
//             </Tooltip>

//             <Tooltip content="Insert reference at your document cursor" relationship="label">
//               <Button 
//                 appearance="primary" 
//                 icon={<DocumentAdd20Regular />} 
//                 className={styles.actionBtn}
//                 style={{ backgroundColor: '#022366' }}
//                 onClick={handleInsertToWord}
//               >
//                 Insert Ref
//               </Button>
//             </Tooltip>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };

// SemanticSearchResults.propTypes = {
//   results: PropTypes.arrayOf(
//     PropTypes.shape({
//       content: PropTypes.string,
//       metadata: PropTypes.shape({
//         id: PropTypes.string,
//         title: PropTypes.string,
//         author: PropTypes.string,
//         journal: PropTypes.string,
//         year: PropTypes.number,
//         volume: PropTypes.string,
//         pages: PropTypes.string,
//         doi: PropTypes.string,
//         url: PropTypes.string,
//         data_provider: PropTypes.string,
//       })
//     })
//   ).isRequired,
//   onLogCopy: PropTypes.func
// };

// export default SemanticSearchResults;




// color change to this light purple..



// import React, { useState } from 'react';
// import PropTypes from 'prop-types';
// import { 
//  Button, 
//  Text, 
//  makeStyles, 
//  shorthands,
//  Badge,
//  Tooltip,
//  mergeClasses
// } from '@fluentui/react-components';
// import { 
//  ClipboardTask20Regular, 
//  DocumentAdd20Regular,
//  BookGlobe20Regular,
//  ChevronDown20Regular,
//  ChevronUp20Regular,
//  ChevronLeft16Regular,
//  ChevronRight16Regular,
//  ThumbLike20Regular,
//  ThumbLike20Filled,
//  ThumbDislike20Regular,
//  ThumbDislike20Filled,
//  ArrowDownload20Regular 
// } from '@fluentui/react-icons';
// import { toast } from 'react-hot-toast';
// import { replaceSelectedContent } from "../utils/officeUtils";

// const useStyles = makeStyles({
//  container: {
//   display: 'flex',
//   flexDirection: 'column',
//   padding: '8px 4px',
//   backgroundColor: 'transparent',
//  },
//  card: {
//   backgroundColor: '#ffffff',
//   // Solid warm light purple border to align with your new theme
//   ...shorthands.border('1px', 'solid', '#f2d4ff'), 
//   ...shorthands.borderRadius('8px'),
//   boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
//   display: 'flex',
//   flexDirection: 'column',
//   overflow: 'hidden',
//  },
//  paginationBar: {
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'center',
//   padding: '6px 12px',
//   // Harmonious warm off-white/light gray tint
//   //backgroundColor: '#f5f4f3', 
//   backgroundColor: '#f2d4ff', // light purple color
//   //borderBottom: '1px solid #706b69',
//   borderBottom: '1px solid #bc36f0',
//  },
//  resultsCount: {
//   fontSize: '11px',
//   fontWeight: '700',
//   color: '#000',
//  },
//  cardHeader: {
//   padding: '16px 16px 8px 16px',
//   backgroundColor: '#ffffff',
//  },
//  foundCount: {
//   fontSize: '12px',
//   fontWeight: '700',
//   color: '#333333',
//   display: 'block',
//   marginBottom: '12px',
//  },
//  titleLink: {
//   fontSize: '13.5px',
//   fontWeight: '600',
//   color: '#0066cc', 
//   textDecorationLine: 'none',
//   display: 'inline-block',
//   marginBottom: '10px',
//   lineHeight: '1.4',
//   ':hover': {
//    textDecorationLine: 'underline',
//    color: '#004b93',
//   }
//  },
//  metaList: {
//   display: 'flex',
//   flexDirection: 'column',
//   gap: '6px',
//  },
//  metaItem: {
//   fontSize: '11px',
//   lineHeight: '1.5',
//   color: '#333333',
//  },
//  accentLabel: {
//   color: '#706b69', // Muted warm gray metadata headers
//   fontWeight: '700',
//   marginRight: '6px',
//  },
//  fullTextLabel: {
//   color: '#706b69', // Full Text label heading
//   fontWeight: '700',
//   fontSize: '11.5px',
//   display: 'block',
//   marginTop: '14px',
//   marginBottom: '4px',
//  },
//  contentBody: {
//   padding: '0 16px 14px 16px',
//   fontSize: '11.5px',
//   color: '#333333',
//   lineHeight: '1.6',
//   backgroundColor: '#ffffff',
//   maxHeight: '300px',
//   overflowY: 'auto',
//  },
//  sectionBlock: {
//   marginBottom: '10px',
//  },
//  sectionTitle: {
//   fontWeight: '700',
//   color: '#706b69',
//   fontSize: '11px',
//   textTransform: 'uppercase',
//   letterSpacing: '0.5px',
//   display: 'block',
//   marginTop: '8px',
//   marginBottom: '4px',
//  },
//  paragraph: {
//   margin: '0 0 8px 0',
//  },
//  cardFooter: {
//   padding: '8px 16px',
//   backgroundColor: '#fafafa',
//   borderTop: '1px solid #f0f0f0',
//   display: 'flex',
//   justifyContent: 'space-between',
//   alignItems: 'center',
//   flexWrap: 'wrap',
//   gap: '8px',
//  },
//  footerActions: {
//   display: 'flex',
//   gap: '8px',
//   alignItems: 'center',
//  },
//  actionBtn: {
//   fontSize: '11px',
//   minWidth: 'auto',
//   padding: '4px 10px',
//  },
//  thumbBtn: {
//   minWidth: '32px',
//   padding: '4px',
//   ':hover': {
//    backgroundColor: '#edebe9',
//   }
//  },
//  toggleBtn: {
//   color: '#605e5c',
//   fontSize: '11px',
//   display: 'flex',
//   alignItems: 'center',
//   gap: '4px',
//   cursor: 'pointer',
//   userSelect: 'none',
//   ':hover': {
//    color: '#706b69',
//   }
//  }
// });

// const parseSectionContent = (text, classes) => {
//  if (!text) return null;
//  const chunks = text.split('\n');

//  return chunks.map((chunk, index) => {
//   const trimmed = chunk.trim();
//   if (!trimmed) return null;

//   if (trimmed.includes('::')) {
//    const parts = trimmed.split('::');
//    const title = parts[0].trim();
//    const body = parts.slice(1).join('::').trim();

//    return (
//     <div key={index} className={classes.sectionBlock}>
//      <span className={classes.sectionTitle}>{}</span>
//      {body && <p className={classes.paragraph}>{body}</p>}
//     </div>
//    );
//   }
//   return <p key={index} className={classes.paragraph}>{trimmed}</p>;
//  });
// };

// const SemanticSearchResults = ({ results, requestLogId, onLogCopy, onFeedbackSubmit }) => {
//  const styles = useStyles();
//  const [currentIndex, setCurrentIndex] = useState(0);
//  const [isExpanded, setIsExpanded] = useState(false);
//  const [feedbackRating, setFeedbackRating] = useState(null);

//  if (!results || results.length === 0) {
//   return (
//    <div style={{ padding: '16px', textAlign: 'center', color: '#605e5c' }}>
//     No search results matched your query criteria.
//    </div>
//   );
//  }

//  const item = results[currentIndex];
//  const meta = item.metadata || {};
//  const truncatedSnippet = item.content && item.content.length > 220 
//   ? item.content.substring(0, 220) + '...' 
//   : item.content;

//  const handleCopyCitation = () => {
//   const citation = `"${meta.title}." ${meta.author}. ${meta.journal} ${meta.year};${meta.volume || ''}:${meta.pages || ''}. doi:${meta.doi}`;
//   navigator.clipboard.writeText(citation);
//   toast.success("Citation copied to clipboard!");
//   if (onLogCopy) onLogCopy(meta.id);
//  };

//  const handleInsertToWord = async () => {
//   const insertionText = `${meta.title} (${meta.author}, ${meta.year}. ${meta.journal}).`;
//   try {
//    if (window.Word) {
//     await replaceSelectedContent(insertionText);
//     toast.success("Reference inserted into document!");
//     if (onLogCopy) onLogCopy(meta.id);
//    } else {
//     toast.error("Word Context missing. Copying citation instead.");
//     navigator.clipboard.writeText(insertionText);
//    }
//   } catch (err) {
//    console.error("Word insertion failed:", err);
//    toast.error("Could not write to document.");
//   }
//  };

//  const handleDownloadJson = () => {
//   try {
//    const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(item, null, 2));
//    const downloadAnchor = document.createElement('a');
//    downloadAnchor.setAttribute("href", dataStr);
   
//    const safeTitle = (meta.title || 'article').toLowerCase().replace(/[^a-z0-9]/g, '_').substring(0, 50);
//    downloadAnchor.setAttribute("download", `article_metadata_${safeTitle}.json`);
//    document.body.appendChild(downloadAnchor);
//    downloadAnchor.click();
//    downloadAnchor.remove();
//    toast.success("JSON file downloaded!");
//   } catch (err) {
//    console.error("JSON extraction failed:", err);
//    toast.error("Failed to generate metadata download.");
//   }
//  };

//  const handleLikeClick = () => {
//   const nextRating = feedbackRating === 1 ? null : 1;
//   setFeedbackRating(nextRating);
//   if (onFeedbackSubmit) {
//    onFeedbackSubmit({
//     request_log_id: requestLogId,
//     rating: nextRating === 1 ? 1 : 0
//    });
//   }
//  };

//  const handleDislikeClick = () => {
//   const nextRating = feedbackRating === -1 ? null : -1;
//   setFeedbackRating(nextRating);
//   if (onFeedbackSubmit) {
//    onFeedbackSubmit({
//     request_log_id: requestLogId,
//     rating: nextRating === -1 ? -1 : 0
//    });
//   }
//  };

//  return (
//   <div className={styles.container}>
//    <div className={styles.card}>
     
//     {/* Carousel Navigation Controller */}
//     <div className={styles.paginationBar}>
//      <Button 
//       appearance="subtle" 
//       icon={<ChevronLeft16Regular />} 
//       disabled={currentIndex === 0} 
//       size="small"
//       onClick={() => {
//        setCurrentIndex(prev => prev - 1);
//        setIsExpanded(false);
//       }}
//      >
//       Prev
//      </Button>
      
//      <Text className={styles.resultsCount}>
//       Document {currentIndex + 1} of {results.length}
//      </Text>

//      <Button 
//       appearance="subtle" 
//       icon={<ChevronRight16Regular />} 
//       iconPosition="after"
//       disabled={currentIndex === results.length - 1} 
//       size="small"
//       onClick={() => {
//        setCurrentIndex(prev => prev + 1);
//        setIsExpanded(false);
//       }}
//      >
//       Next
//      </Button>
//     </div>

//     {/* Card Content Area */}
//     <div className={styles.cardHeader}>
//      <span className={styles.foundCount}>
//       Found : {results.length} article(s)
//      </span>

//      <a 
//       href={meta.url || `https://doi.org/${meta.doi}`} 
//       target="_blank" 
//       rel="noopener noreferrer" 
//       className={styles.titleLink}
//      >
//       {currentIndex + 1}. {meta.title}
//      </a>

//      <div className={styles.metaList}>
//       {meta.doi && (
//        <div className={styles.metaItem}>
//         <span className={styles.accentLabel}>DOI:</span>
//         <span>{meta.doi}</span>
//        </div>
//       )}
//       <div className={styles.metaItem}>
//        <span className={styles.accentLabel}>Journal:</span>
//        <span>{meta.journal}</span>
//       </div>
//       {(meta.volume || meta.pages) && (
//        <div className={styles.metaItem}>
//         <span className={styles.accentLabel}>Publication Details:</span>
//         <span>
//          {[
//           meta.volume ? `Volume: ${meta.volume}` : null,
//           meta.pages ? `Pages: ${meta.pages}` : null
//          ].filter(Boolean).join(', ')}
//         </span>
//        </div>
//       )}
//       <div className={styles.metaItem}>
//        <span className={styles.accentLabel}>Publication Date:</span>
//        <span>{meta.year || 'N/A'}</span>
//       </div>
//       <div className={styles.metaItem}>
//        <span className={styles.accentLabel}>Authors:</span>
//        <span>{meta.author || 'Unknown Authors'}</span>
//       </div>
      
//       {meta.issn && (
//        <div className={styles.metaItem}>
//         <span className={styles.accentLabel}>ISSN:</span>
//         <span>{meta.issn}</span>
//        </div>
//       )}

//       {meta.data_provider && (
//        <div className={styles.metaItem}>
//         <span className={styles.accentLabel}>Data Provider:</span>
//         <span>{meta.data_provider}</span>
//        </div>
//       )}
//      </div>

//      <span className={styles.fullTextLabel}>Full Text</span>
//     </div>

//     {/* Snippet body rendering area */}
//     <div className={styles.contentBody}>
//      {isExpanded ? (
//       parseSectionContent(item.content, styles)
//      ) : (
//       <p className={styles.paragraph}>
//        {truncatedSnippet}
//        {!isExpanded && item.content && item.content.length > 220 && (
//         <span style={{ color: '#706b69', fontWeight: 'bold', cursor: 'pointer', marginLeft: '4px' }} onClick={() => setIsExpanded(true)}>
//          read more
//         </span>
//        )}
//       </p>
//      )}
//     </div>

//     {/* Operation action footers */}
//     <div className={styles.cardFooter}>
//      <div className={styles.toggleBtn} onClick={() => setIsExpanded(!isExpanded)}>
//       {isExpanded ? (
//        <>
//         <Text size={100}>Collapse view</Text>
//         <ChevronUp20Regular style={{ fontSize: '12px' }} />
//        </>
//       ) : (
//        <>
//         <Text size={100}>Expand full text</Text>
//         <ChevronDown20Regular style={{ fontSize: '12px' }} />
//        </>
//       )}
//      </div>

//      <div className={styles.footerActions}>
//       {/* Thumbs Up / Like Button */}
//       <Tooltip content="Like this article" relationship="label">
//        <Button 
//         appearance="subtle" 
//         icon={feedbackRating === 1 ? <ThumbLike20Filled style={{ color: '#706b69' }} /> : <ThumbLike20Regular />} 
//         className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
//         onClick={handleLikeClick}
//        />
//       </Tooltip>

//       {/* Thumbs Down / Dislike Button */}
//       <Tooltip content="Dislike this article" relationship="label">
//        <Button 
//         appearance="subtle" 
//         icon={feedbackRating === -1 ? <ThumbDislike20Filled style={{ color: '#d13438' }} /> : <ThumbDislike20Regular />} 
//         className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
//         onClick={handleDislikeClick}
//        />
//       </Tooltip>

//       {/* JSON Download Button */}
//       <Tooltip content="JSON Download" relationship="label">
//        <Button 
//         appearance="subtle" 
//         icon={<ArrowDownload20Regular />} 
//         className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
//         onClick={handleDownloadJson}
//        />
//       </Tooltip>

//       {/* Copy Button */}
//       <Tooltip content="Copy citation template to clipboard" relationship="label">
//        <Button 
//         appearance="subtle" 
//         icon={<ClipboardTask20Regular />} 
//         className={styles.actionBtn}
//         onClick={handleCopyCitation}
//        >
//         Copy
//        </Button>
//       </Tooltip>

//       {/* Insert Ref Button */}
//       <Tooltip content="Insert reference at your document cursor" relationship="label">
//        <Button 
//         appearance="subtle" 
//         icon={<DocumentAdd20Regular />} 
//         className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
//         onClick={handleInsertToWord}
//        />
//       </Tooltip>
//      </div>
//     </div>

//    </div>
//   </div>
//  );
// };

// SemanticSearchResults.propTypes = {
//  results: PropTypes.arrayOf(
//   PropTypes.shape({
//    content: PropTypes.string,
//    metadata: PropTypes.shape({
//     id: PropTypes.string,
//     title: PropTypes.string,
//     author: PropTypes.string,
//     journal: PropTypes.string,
//     year: PropTypes.number,
//     volume: PropTypes.string,
//     pages: PropTypes.string,
//     doi: PropTypes.string,
//     url: PropTypes.string,
//     data_provider: PropTypes.string,
//     issn: PropTypes.string,
//    })
//   })
//  ).isRequired,
//  requestLogId: PropTypes.string,
//  onLogCopy: PropTypes.func,
//  onFeedbackSubmit: PropTypes.func
// };

// export default SemanticSearchResults;




import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { 
 Button, 
 Text, 
 makeStyles, 
 shorthands,
 Badge,
 Tooltip,
 mergeClasses
} from '@fluentui/react-components';
import { 
 ClipboardTask20Regular, 
 DocumentAdd20Regular,
 BookGlobe20Regular,
 ChevronDown20Regular,
 ChevronUp20Regular,
 ChevronLeft16Regular,
 ChevronRight16Regular,
 ThumbLike20Regular,
 ThumbLike20Filled,
 ThumbDislike20Regular,
 ThumbDislike20Filled,
 ArrowDownload20Regular 
} from '@fluentui/react-icons';
import { toast } from 'react-hot-toast';
import { replaceSelectedContent } from "../utils/officeUtils";
import { useCopyToClipboard } from '../utils/useCopyToClipboard';

const useStyles = makeStyles({
 container: {
  display: 'flex',
  flexDirection: 'column',
  padding: '8px 4px',
  backgroundColor: 'transparent',
 },
 card: {
  backgroundColor: '#ffffff',
  ...shorthands.border('1px', 'solid', '#f2d4ff'), 
  ...shorthands.borderRadius('8px'),
  boxShadow: '0 2px 8px rgba(0,0,0,0.05)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
 },
 paginationBar: {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '6px 12px',
  backgroundColor: '#f2d4ff', 
  borderBottom: '1px solid #bc36f0',
 },
 resultsCount: {
  fontSize: '11px',
  fontWeight: '700',
  color: '#000',
 },
 cardHeader: {
  padding: '16px 16px 12px 16px',
  backgroundColor: '#ffffff',
  borderBottom: '1px solid #f0f0f0',
 },
 foundCount: {
  fontSize: '12px',
  fontWeight: '700',
  color: '#333333',
  display: 'block',
  marginBottom: '12px',
 },
 titleLink: {
  fontSize: '13.5px',
  fontWeight: '600',
  color: '#0066cc', 
  textDecorationLine: 'none',
  display: 'inline-block',
  marginBottom: '4px',
  lineHeight: '1.4',
  ':hover': {
   textDecorationLine: 'underline',
   color: '#004b93',
  }
 },
 authorText: {
  fontSize: '11.5px',
  color: '#605e5c',
  fontStyle: 'italic',
  display: 'block',
  marginBottom: '8px',
 },
 citationLine: {
  display: 'flex',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '2px',
  fontSize: '11px',
  color: '#605e5c',
  marginBottom: '10px',
 },
 citationBullet: {
  color: '#8a8886',
  margin: '0 6px',
  fontSize: '10px',
 },
 badgeRow: {
  display: 'flex',
  gap: '8px',
  flexWrap: 'wrap',
  marginTop: '4px',
 },
 providerBadge: {
  backgroundColor: '#fff', 
  color: '#000',
  fontSize: '10px',
  padding: '2px 10px',
  borderRadius: '100px',
  fontWeight: '700',
  ...shorthands.border('2px'),
 },
 doiBadge: {
  fontSize: '10px',
  borderColor: '#000',
  color: '#000', 
  padding: '2px 10px',
  borderRadius: '100px',
  backgroundColor: '#fafafa',
  fontWeight: '600',
 },
 genericBadge: {
  fontSize: '10px',
  borderColor: '#d2d0ce',
  color: '#333333',
  padding: '2px 10px',
  borderRadius: '100px',
  backgroundColor: '#fafafa',
  fontWeight: '600',
 },
 contentBody: {
  padding: '14px 16px', 
  fontSize: '12.5px',
  color: '#333333',
  lineHeight: '1.6',
  backgroundColor: '#ffffff',
  maxHeight: '300px',
  overflowY: 'auto',
 },
 sectionBlock: {
  marginBottom: '10px',
 },
 sectionTitle: {
  fontWeight: '700',
  color: '#706b69',
  fontSize: '11px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
  display: 'block',
  marginTop: '8px',
  marginBottom: '4px',
 },
 paragraph: {
  margin: '0 0 8px 0',
 },
 cardFooter: {
  padding: '8px 16px',
  backgroundColor: '#fafafa',
  borderTop: '1px solid #f0f0f0',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: '8px',
 },
 footerActions: {
  display: 'flex',
  gap: '8px',
  alignItems: 'center',
 },
 actionBtn: {
  fontSize: '11px',
  minWidth: 'auto',
  padding: '4px 10px',
 },
 thumbBtn: {
  minWidth: '32px',
  padding: '4px',
  ':hover': {
   backgroundColor: '#edebe9',
  }
 },
 toggleBtn: {
  color: '#605e5c',
  fontSize: '11px',
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  cursor: 'pointer',
  userSelect: 'none',
  ':hover': {
   color: '#706b69',
  }
 },
 helpCursor: {
  cursor: 'help',
 }
});

const parseSectionContent = (text, classes) => {
 if (!text) return null;
 const chunks = text.split('\n');

 return chunks.map((chunk, index) => {
  const trimmed = chunk.trim();
  if (!trimmed) return null;

  if (trimmed.includes('::')) {
   const parts = trimmed.split('::');
   const title = parts[0].trim();
   const body = parts.slice(1).join('::').trim();

   return (
    <div key={index} className={classes.sectionBlock}>
     <span className={classes.sectionTitle}>{}</span>
     {body && <p className={classes.paragraph}>{body}</p>}
    </div>
   );
  }
  return <p key={index} className={classes.paragraph}>{trimmed}</p>;
 });
};

const SemanticSearchResults = ({ results, requestLogId, onLogCopy, onFeedbackSubmit }) => {
 const styles = useStyles();
 const [currentIndex, setCurrentIndex] = useState(0);
 const [isExpanded, setIsExpanded] = useState(false);
 const [feedbackRating, setFeedbackRating] = useState(null);

     const [isCopied, copy] = useCopyToClipboard(); // <-- Add this line

 // if (!results || results.length === 0) {
 //  return (
 //   <div style={{ padding: '16px', textAlign: 'center', color: '#605e5c' }}>
 //    No search results matched your query criteria.
 //   </div>
 //  );
 // }

     if (!results || results.length === 0) {
  return (
   <div className={styles.container}>
    <div className={styles.card}>
     {/* Clean light purple pagination bar indicating 0 results */}
     <div className={styles.paginationBar}>
      <Text className={styles.resultsCount}>
       Found : 0 article(s)
      </Text>
     </div>
     {/* Styled body copy wrapper matching the font and colors of the card snippet */}
     <div style={{ padding: '24px 16px', textAlign: 'center', color: '#706b69', fontSize: '11.5px', lineHeight: '1.5' }}>
      No search results matched your query criteria. Please adjust your keywords or try applying different filters.
     </div>
    </div>
   </div>
  );
 }

 const item = results[currentIndex];
 const meta = item.metadata || {};
 const truncatedSnippet = item.content && item.content.length > 220 
  ? item.content.substring(0, 220) + '...' 
  : item.content;

 // const handleCopyCitation = () => {
 //  const citation = `"${meta.title}." ${meta.author}. ${meta.journal} ${meta.year};${meta.volume || ''}:${meta.pages || ''}. doi:${meta.doi}`;
 //    copy(citation);
 //  //navigator.clipboard.writeText(citation);
 //  //toast.success("Citation copied to clipboard!");
 //  if (onLogCopy) onLogCopy(meta.id);
 // };

     const handleCopyCitation = () => {
  // 1. Build the clean, professional academic citation line
  const citation = `"${meta.title || 'Untitled Article'}." ${meta.author || 'Unknown Authors'}. ${meta.journal || 'Unknown Journal'} ${meta.year || ''};${meta.volume || ''}${meta.pages ? ':' + meta.pages : ''}.${meta.doi ? ' doi:' + meta.doi : ''}`;
  
  // 2. Retrieve the complete, un-truncated full text content
  const articleContent = item.content || "";
  
  // 3. Combine both with a clean paragraph break
  const fullTextToCopy = `${citation}\n\n${articleContent}`;
  
  // 4. Copy the complete package to the clipboard
  copy(fullTextToCopy); 
  
  if (onLogCopy) onLogCopy(meta.id);
 };

 // const handleInsertToWord = async () => {
 //  const insertionText = `${meta.title} (${meta.author}, ${meta.year}. ${meta.journal}).`;
 //  try {
 //   if (window.Word) {
 //    await replaceSelectedContent(insertionText);
 //    toast.success("Reference inserted into document!");
 //    if (onLogCopy) onLogCopy(meta.id);
 //   } else {
 //    toast.error("Word Context missing. Copying citation instead.");
 //    navigator.clipboard.writeText(insertionText);
 //   }
 //  } catch (err) {
 //   console.error("Word insertion failed:", err);
 //   toast.error("Could not write to document.");
 //  }
 // };

const handleInsertToWord = async () => {
  const insertionText = `${meta.title} (${meta.author}, ${meta.year}. ${meta.journal}).`;
  try {
   if (window.Word) {
    await replaceSelectedContent(insertionText);
    toast.success("Reference inserted into document!");
    if (onLogCopy) onLogCopy(meta.id);
   } else {
    toast.error("Word Context missing. Copying citation instead.");

    copy(insertionText); // 🔍 FIXED: Safely copies reference using the hook's fallback

   }
  } catch (err) {
   console.error("Word insertion failed:", err);
   toast.error("Could not write to document.");
  }
 };

 const handleDownloadJson = () => {
  try {
   const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(item, null, 2));
   const downloadAnchor = document.createElement('a');
   downloadAnchor.setAttribute("href", dataStr);
   
   const safeTitle = (meta.title || 'article').toLowerCase().replace(/[^a-z0-9]/g, '_').substring(0, 50);
   downloadAnchor.setAttribute("download", `article_metadata_${safeTitle}.json`);
   document.body.appendChild(downloadAnchor);
   downloadAnchor.click();
   downloadAnchor.remove();
   toast.success("JSON file downloaded!");
  } catch (err) {
   console.error("JSON extraction failed:", err);
   toast.error("Failed to generate metadata download.");
  }
 };

 const handleLikeClick = () => {
  const nextRating = feedbackRating === 1 ? null : 1;
  setFeedbackRating(nextRating);
  if (onFeedbackSubmit) {
   onFeedbackSubmit({
    request_log_id: requestLogId,
    rating: nextRating === 1 ? 1 : 0
   });
  }
 };

 const handleDislikeClick = () => {
  const nextRating = feedbackRating === -1 ? null : -1;
  setFeedbackRating(nextRating);
  if (onFeedbackSubmit) {
   onFeedbackSubmit({
    request_log_id: requestLogId,
    rating: nextRating === -1 ? -1 : 0
   });
  }
 };

 return (
  <div className={styles.container}>
   <div className={styles.card}>
     
    {/* Carousel Navigation Controller */}
    <div className={styles.paginationBar}>
     <Button 
      appearance="subtle" 
      icon={<ChevronLeft16Regular />} 
      disabled={currentIndex === 0} 
      size="small"
      onClick={() => {
       setCurrentIndex(prev => prev - 1);
       setIsExpanded(false);
      }}
     >
      Prev
     </Button>
      
     <Text className={styles.resultsCount}>
      Document {currentIndex + 1} of {results.length}
     </Text>

     <Button 
      appearance="subtle" 
      icon={<ChevronRight16Regular />} 
      iconPosition="after"
      disabled={currentIndex === results.length - 1} 
      size="small"
      onClick={() => {
       setCurrentIndex(prev => prev + 1);
       setIsExpanded(false);
      }}
     >
      Next
     </Button>
    </div>

    {/* Card Header matching screenshot layout */}
    <div className={styles.cardHeader}>
     <span className={styles.foundCount}>
      Found : {results.length} article(s)
     </span>

     {/* Title Link */}
     <a 
      href={meta.url || `https://doi.org/${meta.doi}`} 
      target="_blank" 
      rel="noopener noreferrer" 
      className={styles.titleLink}
     >
      {currentIndex + 1}. {meta.title}
     </a>

    {/* Author Line right under the title wrapped in a Tooltip */}
     <Tooltip content="Authors" relationship="label">
      <span className={mergeClasses(styles.authorText, styles.helpCursor)}>
       {meta.author || 'Unknown Authors'}
      </span>
     </Tooltip>

     {/* Inline citation string with Globe icon & descriptive Tooltips */}
     <div className={styles.citationLine}>
      <BookGlobe20Regular style={{ color: '#0056b3', fontSize: '14px', marginRight: '4px' }} />
      
      {meta.journal && (
       <Tooltip content="Journal Name" relationship="label">
        <Text size={100} className={styles.helpCursor}>{meta.journal}</Text>
       </Tooltip>
      )}

      {meta.journal && (meta.year || meta.year === 0) && <span className={styles.citationBullet}>•</span>}

      {meta.year && (
       <Tooltip content="Publication Year" relationship="label">
        <Text size={100} className={styles.helpCursor}>{meta.year}</Text>
       </Tooltip>
      )}

      {(meta.journal || meta.year) && meta.volume && <span className={styles.citationBullet}>•</span>}

      {meta.volume && (
       <Tooltip content="Volume" relationship="label">
        <Text size={100} className={styles.helpCursor}>Vol: {meta.volume}</Text>
       </Tooltip>
      )}
     </div>

     {/* Badges Capsule Row with descriptive Tooltips */}
     <div className={styles.badgeRow}>
      {meta.data_provider && (
       <Tooltip content="Data Provider" relationship="label">
        <Badge className={mergeClasses(styles.genericBadge, styles.helpCursor)} appearance="outline">
         {meta.data_provider}
        </Badge>
       </Tooltip>
      )}
      
      {meta.doi && (
       <Tooltip content="Digital Object Identifier (DOI)" relationship="label">
        <Badge className={mergeClasses(styles.doiBadge, styles.helpCursor)} appearance="outline">
         DOI: {meta.doi}
        </Badge>
       </Tooltip>
      )}

      {meta.issn && (
       <Tooltip content="International Standard Serial Number (ISSN)" relationship="label">
        <Badge className={mergeClasses(styles.genericBadge, styles.helpCursor)} appearance="outline">
         ISSN: {meta.issn}
        </Badge>
       </Tooltip>
      )}
     </div>
    </div>

    {/* Snippet body rendering area */}
    <div className={styles.contentBody}>
     {isExpanded ? (
      parseSectionContent(item.content, styles)
     ) : (
      <p className={styles.paragraph}>
       {truncatedSnippet}
       {!isExpanded && item.content && item.content.length > 220 && (
        <span style={{ color: '#706b69', fontWeight: 'bold', cursor: 'pointer', marginLeft: '4px' }} onClick={() => setIsExpanded(true)}>
         read more
        </span>
       )}
      </p>
     )}
    </div>

    {/* Operation action footers */}
    <div className={styles.cardFooter}>
     <div className={styles.toggleBtn} onClick={() => setIsExpanded(!isExpanded)}>
      {isExpanded ? (
       <>
        <Text size={100}>Collapse view</Text>
        <ChevronUp20Regular style={{ fontSize: '12px' }} />
       </>
      ) : (
       <>
        <Text size={100}>Expand full text</Text>
        <ChevronDown20Regular style={{ fontSize: '12px' }} />
       </>
      )}
     </div>

     <div className={styles.footerActions}>
      {/* Thumbs Up / Like Button */}
      <Tooltip content="Like this article" relationship="label">
       <Button 
        appearance="subtle" 
        icon={feedbackRating === 1 ? <ThumbLike20Filled style={{ color: '#706b69' }} /> : <ThumbLike20Regular />} 
        className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
        onClick={handleLikeClick}
       />
      </Tooltip>

      {/* Thumbs Down / Dislike Button */}
      <Tooltip content="Dislike this article" relationship="label">
       <Button 
        appearance="subtle" 
        icon={feedbackRating === -1 ? <ThumbDislike20Filled style={{ color: '#d13438' }} /> : <ThumbDislike20Regular />} 
        className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
        onClick={handleDislikeClick}
       />
      </Tooltip>

      {/* JSON Download Button */}
      <Tooltip content="JSON Download" relationship="label">
       <Button 
        appearance="subtle" 
        icon={<ArrowDownload20Regular />} 
        className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
        onClick={handleDownloadJson}
       />
      </Tooltip>

      {/* Copy Button */}
      <Tooltip content="Copy citation template to clipboard" relationship="label">
       <Button 
        appearance="subtle" 
        icon={<ClipboardTask20Regular />} 
        className={styles.actionBtn}
        onClick={handleCopyCitation}
       >
        Copy
       </Button>
      </Tooltip>

      {/* Insert Ref Button */}
      <Tooltip content="Insert reference at your document cursor" relationship="label">
       <Button 
        appearance="subtle" 
        icon={<DocumentAdd20Regular />} 
        className={mergeClasses(styles.actionBtn, styles.thumbBtn)}
        onClick={handleInsertToWord}
       />
      </Tooltip>
     </div>
    </div>

   </div>
  </div>
 );
};

SemanticSearchResults.propTypes = {
 results: PropTypes.arrayOf(
  PropTypes.shape({
   content: PropTypes.string,
   metadata: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    author: PropTypes.string,
    journal: PropTypes.string,
    year: PropTypes.number,
    volume: PropTypes.string,
    pages: PropTypes.string,
    doi: PropTypes.string,
    url: PropTypes.string,
    data_provider: PropTypes.string,
    issn: PropTypes.string,
   })
  })
 ).isRequired,
 requestLogId: PropTypes.string,
 onLogCopy: PropTypes.func,
 onFeedbackSubmit: PropTypes.func
};

export default SemanticSearchResults;